import xss from 'xss'

const excludedDataIs = ['TwoColumnBanner', 'Promo']
const query = `table${excludedDataIs.map(name => `:not([data-is="${name}"] table)`).join('')}`

export function addTableWrappers(): void {
  const tables: NodeListOf<HTMLTableElement> = document.querySelectorAll(query)
  tables.forEach((table: HTMLTableElement) => {
    const parent: ParentNode | null = table.parentNode
    if (!parent) {
      return
    }

    // Skip tables already wrapped in a .table-responsive container (idempotence guard)
    if (
      parent instanceof Element &&
      parent.classList.contains('table-responsive')
    ) {
      return
    }

    const wrapper: HTMLDivElement = document.createElement('div')
    wrapper.classList.add('table-responsive')

    const sanitizedTable: HTMLTableElement = document.createElement('table')

    Array.from(table.attributes).forEach((attr: Attr) => {
      sanitizedTable.setAttribute(attr.name, attr.value)
    })

    sanitizedTable.innerHTML = xss(table.innerHTML)

    // replace original with sanitized table wrapped in div featuring class table-responsive
    wrapper.appendChild(sanitizedTable)
    parent.insertBefore(wrapper, table)
    parent.removeChild(table)
  })
}
